module.exports = __webpack_public_path__ + "static/media/edit-white.609b0984.svg";